<template>
  <div id="bar" :style="size">
    <div style="color: white;font-size: 22px;margin-left: 30px;margin-top: 20px">
      <i className='iconfont'>&#xe7f7;</i>
      <span>日销量分物资</span>
    </div>
    <e-charts :size="size" style="margin-top:10px;height: 340px;overflow: hidden" :options="options"/>
  </div>
</template>

<script>
import ECharts from './ECharts'
import * as echarts from 'echarts';

export default {
  components: {
    ECharts
  },
  props: {
    dailyCoal: {   // 物资
      type: Object,
      default: () => ({})
    },
    dailyWeight: {  // 净重
      type: Object,
      default: () => ({})
    }
  },
  created() {
  },
  data: function () {
    return {
      year: 2000,
      // 基础柱状图
      options: {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          left: '3%',
          right: '10%',
          bottom: '3%',
          containLabel: true
        },
        legend: {
          textStyle: {
            color: 'white'
          },
        },
        xAxis: [
          {
            axisLine: {
              lineStyle: {
                color: 'white'
              },
            },
            axisTick: {       // y轴刻度线
              show: false
            },
            name: '物资 ',
            type: 'category',
            data: JSON.parse(JSON.stringify(this.dailyCoal)),
          }
        ],
        yAxis: [
          {
            name: '净重',
            axisLine: {
              lineStyle: {
                color: 'white'
              },
            },
            axisTick: {       // y轴刻度线
              show: false
            },
            splitLine: {
              show: true,  // 网格线
              lineStyle: {
                type: 'dashed'
              }
            },
            type: 'value'
          }
        ],
        series: [
          {
            itemStyle: {
              normal: {
                label: {
                  show: true, // 开启显示
                  position: 'top', // 在上方显示
                  textStyle: { // 数值样式
                    color: 'white',
                    fontSize: 12
                  }
                },
                color: new echarts.graphic.LinearGradient(
                  0, 1, 0, 0,
                  [
                    {offset: 0, color: '#4C60FE'},
                    {offset: 1, color: '#6F7CE2'}
                  ]
                )
              }
            },
            name: '数量',
            type: 'bar',
            emphasis: {
              focus: 'series'
            },
            data: JSON.parse(JSON.stringify(this.dailyWeight)),
          },
        ]
      },
      size: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '390px'
      }
    }
  },
}
</script>

<style scoped>
</style>






